import { apiClient, endpoints, unwrap } from '@core/api';
import { env } from '@config/env';

function cleanDomain(domain) {
  return String(domain || '')
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/$/, '');
}

export async function resolveStoreByDomain({ domain }) {
  const payload = {
    domain: cleanDomain(domain),
  };

  const raw = await apiClient.post(endpoints.public.storeResolve, {
    data: payload,
    headers: {
      'x-api-key': env.publicResolveApiKey || '',
    },
    skipAuth: true,
  });
  const { data } = unwrap(raw);
  return data ?? raw;
}
